module.exports = __webpack_public_path__ + "static/img/twjd-sde5.d3614ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde5.png
// module id = 841
// module chunks = 0